
import { Component, Vue, Watch } from 'vue-property-decorator'
import MainLayout from '@/layout/main/MainLayout.vue'
import { ConfigProvider } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { useTokenStore } from '@/store/token'
import { useUserStore } from '@/store/user'
import { useMixAuthStore } from '@/store/mix-auth'
import PreviewImg from '@/components/preview-img/Index.vue'
import PreviewVideo from '@/components/preview-video/Index.vue'

const tokenStore = useTokenStore()

@Component({
  name: 'App',
  components: { MainLayout, ConfigProvider, PreviewImg, PreviewVideo },
})
export default class App extends Vue {
  private locale = zhCN
  private location = location
  private preToken = ''
  private preMixAuthToken = ''
  private userStore = useUserStore()
  private mixAuthStore = useMixAuthStore()

  @Watch('userStore.info.id', { immediate: true })
  private userIdChange(id) {
    if (id) {
      this.preToken = tokenStore.getToken()
    }
  }

  @Watch('mixAuthStore.userName', { immediate: true })
  private mixAuthStoreTokenChange(name) {
    if (name) {
      this.preMixAuthToken = this.mixAuthStore.getToken() || ''
    }
  }

  private created() {
    document.addEventListener('visibilitychange', () => {
      const notWorkbenchPage = !location.pathname.startsWith('/workbench')
      if (this.preToken && tokenStore.getToken() && this.preToken !== tokenStore.getToken() && notWorkbenchPage) {
        this.preToken = tokenStore.getToken()
        this.$message.warning('用户信息改变')
        this.$router.push('/hall')
        setTimeout(() => {
          location.reload()
        })
      }

      if (this.preMixAuthToken !== (this.mixAuthStore.getToken() || '')) {
        this.preMixAuthToken = this.mixAuthStore.getToken() || ''
        this.$message.warning('登录授权信息改变')
        this.$router.push('/hall')
        setTimeout(() => {
          location.reload()
        })
      }
    })
  }
}
